import { PaymentType } from '../../../sharedcomponents/_common/constants/app.constants';
export class currentcartdetail {
  CartExpiry: string = '';
  CustmerPaymentMethod: number = 0;
  FundingId: string = '0';
  GuaranteedCancellationPeriod: string = '';
  ItemCount: string = '';
  StoreId: string = '';
  StoreName: string = '';
  SuperSend: string = '';
  UnReadMessageCount='';
}

export class ShopingCart {
  itemId: string = '';
}
export class ShopingCartList {
  List: Array<ShopingCart>;
}



// WEBPACK FOOTER //
// ./src/app/models/dashboard/cart/mywallet.currentcart.Modal.ts